export const IS_DEV = import.meta.env.MODE === 'development';
export const DOMAIN = import.meta.env.VITE_DOMAIN || 'http://localhost:1105';
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://localhost:7041';
export const SEGMENT_ANALYTICS_KEY = import.meta.env.VITE_SEGMENT_API_KEY || '';
export const SEGMENT_ENV = import.meta.env.VITE_SEGMENT_ENV || '';
export const SEGMENT_COOKIE_DOMAIN = import.meta.env.VITE_SEGMENT_COOKIE_DOMAIN || '';
export const HUBSPOT_HUB_ID = import.meta.env.VITE_HUBSPOT_HUB_ID || '';
export const DISABLE_DATA_PERSISTANCE = import.meta.env.VITE_DISABLE_DATA_PERSISTANCE;
export const DATE_FORMAT = 'DD-MM-YYYY';

export const MSW_LOGGING = import.meta.env.VITE_MSW_LOGGING
  ? import.meta.env.VITE_MSW_LOGGING === 'false'
  : true;
export const MSW_UNHANDLED_REQUESTS = import.meta.env.VITE_MSW_UNHANDLED_REQUESTS || 'bypass';
export const VITE_MOCK_ONLY = import.meta.env.VITE_MOCK_ONLY === 'true';
// Must be VITE_-prefixed: Vite only exposes VITE_* vars on import.meta.env, so the
// previous non-prefixed ENABLE_SENTRY_RELEASE was always undefined at runtime and
// Sentry.init was dead-code-eliminated from every build (DL-61312).
export const IS_MOCK_SENTRY = import.meta.env.VITE_SENTRY_DSN === 'mock';
export const SENTRY_DSN = IS_MOCK_SENTRY
  ? 'https://mock@mock.ingest.sentry.io/0'
  : import.meta.env.VITE_ENABLE_SENTRY_RELEASE?.toLowerCase() === 'true'
    ? import.meta.env.VITE_SENTRY_DSN
    : undefined;
export const DISABLE_IFRAME_BG_LOADING = import.meta.env.VITE_DISABLE_IFRAME_BG_LOADING === 'true';
export const MOCK_TIMING = import.meta.env.VITE_MOCK_TIMING;
export const MOCK_LOGIN = import.meta.env.VITE_MOCK_LOGIN?.toLowerCase() === 'true';
export const PROFILING_BUILD = import.meta.env.VITE_REACT_PROFILING?.toLowerCase() === 'true';

export const USE_FEDERATED_AUTH = import.meta.env.VITE_USE_FEDERATED_AUTH?.toLowerCase() === 'true';
// LOCAL DEV ONLY: a user API key sent to Delogue.API as `X-Auth-Token` so the new API can be
// exercised while VITE_USE_FEDERATED_AUTH stays false (federated/Auth0 work not done yet). Set
// VITE_DELOGUE_API_KEY in frontend/.env.local; leave it UNSET in every deployed environment —
// there the DelogueApiGuard then honestly shows "not available". Never commit an actual key value.
export const DELOGUE_API_KEY = import.meta.env.VITE_DELOGUE_API_KEY || null;
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE;

export const CONTACT_SUPPORT_URL =
  import.meta.env.VITE_CONTACT_SUPPORT_URL || 'https://knowledge.delogue.com/kb-tickets/new';
